// extracted by mini-css-extract-plugin
export default {"container":"Profile_container__1PLGm","content":"Profile_content__M26F4","headerPopupCont":"Profile_headerPopupCont__5ryP3"};